export default () => {
  document.addEventListener('click', handleEvent);
  document.addEventListener('keyup', handleEvent);

  function handleEvent(e) {
    if (e.target.closest('[data-rte-video]')) {
      console.log(e);
      const videoContainer = e.target.closest('[data-rte-video]');
      const video = videoContainer.querySelector('iframe');
      let src = video.getAttribute('src');
      let autoplaySrc = src;

      if (src.indexOf('?') > -1) {
        autoplaySrc += '&';
      } else {
        autoplaySrc += '?';
      }

      autoplaySrc += 'autoplay=1';
      video.setAttribute('src', autoplaySrc);
      videoContainer.querySelector('.RteVideo__cover--active').classList.remove('RteVideo__cover--active');
    }
  }
};
